export const validatePasswordComplexity = (password) => {
  const errors = [];
  
  if (!password) {
    errors.push('Password is required');
    return errors;
  }
  
  if (password.length < 12) {
    errors.push('Password must be at least 12 characters');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one digit');
  }
  
  if (!/[!@#^&*]/.test(password)) {
    errors.push('Password must contain at least one special character (!@#^&*)');
  }
  
  return errors;
};

export const isPasswordValid = (password) => {
  return validatePasswordComplexity(password).length === 0;
};
